import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqList } from "@/mocks/faq";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="w-full px-4 py-16 md:px-8 md:py-24">
      <SectionHeading
        eyebrow="常见问题"
        title="关于新番站的一些说明"
        description="把追番过程中常遇到的小疑问集中整理在这里，方便快速了解本站内容的使用方式。"
        align="center"
      />

      <div className="mx-auto mt-9 max-w-3xl divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {faqList.map((item, index) => {
          const open = openIndex === index;
          return (
            <div key={item.q}>
              <button
                type="button"
                aria-expanded={open}
                onClick={() => toggle(index)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100/60"
              >
                <span className="flex items-center gap-3 text-sm text-foreground-950 md:text-base">
                  <i className="ri-question-line text-primary-500" />
                  {item.q}
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                    open ? "ri-subtract-line" : "ri-add-line"
                  }`}
                />
              </button>
              {open ? (
                <p className="px-5 pb-5 pl-11 text-sm leading-relaxed text-foreground-600">
                  {item.a}
                </p>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}